import { render } from "./InputText.vue?vue&type=template&id=574c3a6f&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=574c3a6f&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574c3a6f"]])

export default __exports__